module.exports = __webpack_public_path__ + "img/Trupp_UL.b381d032.svg";